import { acceptOnlyValidOptionByValue } from '../../field-viewer/shared-normalizers';
export const mlaCountryViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByValue
};

//# sourceMappingURL=definition-viewer.js.map